// Splide init
function mmInitSplide() {
  const id = '.mm-splide-crossell';
  const splideElem = document.querySelector(id);
  const idrea = '.splide-cta-testimonials';
  const splideElemrea = document.querySelector(idrea);

  if (splideElem) {
    new Splide(splideElem, {
      type   : 'splide',
      arrows: false,
      pagination: false,
      rewind: true,
      gap: 8,
      perPage: 2
      }).mount(); 
  }
  
  if (splideElemrea) {    
    new Splide( splideElemrea, {
        type   : 'loop',
        arrows: false,
        pagination: true,
        gap: 0,
        perPage: 1,
        autoplay: true,
        interval: 3000
    }).mount();  
  }
}


// DISCOUNT CODE
function removeDiscount() {
	fetch(window.Shopify.routes.root + 'cart/update.js', {
	  method: 'POST',
	  headers: {
		'Content-Type': 'application/json'
	  },
	  body: JSON.stringify({ discount: '' })
	})
	  .then(res => res.json())
	  .then(data => {
		// Utiliser la fonction custom de rafraîchissement du panier
		mmOpenAndRefreshCart();
	  })
	  .catch(err => {
		console.error('Erreur lors du retrait du code promo :', err);
		alert('Erreur lors du retrait.', false);
	  });
  }
  
  async function mmApplyDiscountInCart() {
    const codeInput = document.getElementById('discount-code');
    const newCode = codeInput.value.trim();
    if (!newCode) return;

    const applyBtn = document.getElementById('apply-discount');
    const originalBtnText = applyBtn.textContent;
    applyBtn.disabled = true;
    applyBtn.textContent = '...';

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: newCode })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Code promo invalide');
      }

      // Si le code est valide, on rafraîchit le contenu du panier
      mmRefreshCartContent(() => {
        applyBtn.disabled = false;
        applyBtn.textContent = originalBtnText;
        codeInput.value = '';
      });

    } catch (err) {
      displayPromoError(err.message);
      applyBtn.disabled = false;
      applyBtn.textContent = originalBtnText;
    }
  }
  
  // Affiche un message d’erreur sous le formulaire
  function displayPromoError(message) {
	let errorElem = document.querySelector('.promo-error');
	if (!errorElem) {
	  errorElem = document.createElement('div');
	  errorElem.className = 'promo-error text-xs text-red-600 mt-2';
	  const form = document.getElementById('discount-form') || document.body;
	  form.appendChild(errorElem);
	}
	errorElem.textContent = message;
  }
  
// drop down discount
const mmDiscountAccordionClickHandler = () => {
  const discountWrapper = document.querySelector('.mm-discount-wrapper');
  if (discountWrapper) {
      discountWrapper.classList.toggle('mm-open');
  }
};

function mmInitDiscountAccordion() {
  const discountHeader = document.querySelector('.mm-discount-header');
  if (discountHeader) {
      discountHeader.removeEventListener('click', mmDiscountAccordionClickHandler);
      discountHeader.addEventListener('click', mmDiscountAccordionClickHandler);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  mmInitSplide();
  mmInitDiscountAccordion();
}, { once: true });

// Debounce
// https://redd.one/blog/debounce-vs-throttle
// If function is called several times in {duration},
// wait for a pause longer than {duration} to actually trigger it.
// eg, wait 500 milliseconds after last call to actually call doSomething():
// debounce(function () {
//    doSomething();
//  }, 500)
function debounce(func, duration) {
  let timeout;
  return function (...args) {
    const effect = () => {
      timeout = null;
      return func.apply(this, args);
    }
    clearTimeout(timeout);
    timeout = setTimeout(effect, duration);
  }
}

function mmCartSectionElement() {
  return document.getElementById('shopify-section-mm-cart');
}

function mmCartProductsContainerElement() {
  return mmCartSectionElement().querySelector('.mm-dc-products-container');
}

function mmCartItem(productVariantId) {
  return mmCartProductsContainerElement()
           .querySelector(`[data-cart-item-id="${productVariantId}"]`);
}

function mmCartItemQuantityEl(productVariantId) {
  const itemEl = mmCartItem(productVariantId);
  
  return itemEl.querySelector("[data-item-quantity]");
}

function mmGetCartItemQuantity(productVariantId) {
  const quantityEl = mmCartItemQuantityEl(productVariantId);

  return Number.parseInt(quantityEl.dataset.itemQuantity);
}

function mmSetCartItemQuantity(productVariantId, newQuantity) {
  // Display qtty in front
  if (newQuantity >= 0) {
    const quantityEl = mmCartItemQuantityEl(productVariantId);

    quantityEl.dataset.itemQuantity = newQuantity;
    quantityEl.innerText = newQuantity; 
  }
}

function mmCartHTMLFromData(data) {
  const el = document.createElement('DIV');
  el.innerHTML = data.sections["mm-cart"];
  
  return el;
}

function extractItemsFromCartHTML(data) {
  const el = mmCartHTMLFromData(data);
  return el.querySelector('.mm-dc-products-container');
}

function insertCartProductsFromResponse(data) {
  const itemsContainer = extractItemsFromCartHTML(data);
  mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;

  return data;
}

function extractTotalPriceFromCartHTML(data) {
  const cartEl = mmCartHTMLFromData(data); // ¡ fait atención gringo !
  return cartEl.querySelector('[data-cart-total-price]');
}

function insertInsertTotalPriceFromResponse(data) {
  const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
  const currentTotalPriceEl = mmCartSectionElement().querySelector('[data-cart-total-price]');
  currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;

  return data;
}

function mmAPIRequest(method, path, body) {
  document.querySelector('.mm-dc-products')?.classList?.add('mm-inactive');
  return fetch(window.Shopify.routes.root + path, {
    method: method,
    headers: { 'Content-Type': 'application/json' }, 
    body: JSON.stringify(body)
  }).then(response => response.json())
    .then((data) =>  {
      // mmLog(data);
      document.querySelector('.mm-dc-products')?.classList?.remove('mm-inactive');
      if (data.status && data.status > 400) {
        throw(data);
      } else {
        return data;
      }
    });
}

// récupérer le panier
function mmGetCart() {
  return mmAPIRequest('GET', 'cart.js');
}

// Ouvrir le panier
function mmOpenCart() {
  mmGetCart();
  mmInitDiscountAccordion();
  document.querySelector('.mm-drawer-cart-filter').classList.add('mm-dc-is-open');
  document.querySelector('html').classList.add('stop-scrolling');
}

// Ouvrir et refresh le panier (utilisé pour faire fonctionner les babybox et superbox avec le panier)
function mmOpenAndRefreshCart() {
  const discountWrapper = document.querySelector('.mm-discount-wrapper');
  const wasOpen = discountWrapper && discountWrapper.classList.contains('mm-open');

  function handleResponse() {    
    const newCartEl = document.createElement('DIV');
    newCartEl.innerHTML = this.responseText;
    const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-filter");
    innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-filter").innerHTML;
    mmInitSplide();
    console.log('Panier rechargé via mmOpenAndRefreshCart');
    mmInitDiscountAccordion();

    if (wasOpen) {
      const newDiscountWrapper = document.querySelector('.mm-discount-wrapper');
      if (newDiscountWrapper) {
        newDiscountWrapper.classList.add('mm-open');
      }
    }

    document.querySelector('.mm-drawer-cart-filter').classList.add('mm-dc-is-open');  
    document.querySelector('html').classList.add('stop-scrolling');
  }
  const request = new XMLHttpRequest();
  request.addEventListener('load', handleResponse);
  request.open('GET', '/?section_id=mm-cart', true)
  request.send()
}

// Recharge le contenu du panier sans l'ouvrir
function mmRefreshCartContent(callback) {
  const discountWrapper = document.querySelector('.mm-discount-wrapper');
  const wasOpen = discountWrapper && discountWrapper.classList.contains('mm-open');

  function handleResponse() {
    const newCartEl = document.createElement('DIV');
    newCartEl.innerHTML = this.responseText;
    const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-filter");
    innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-filter").innerHTML;
    mmInitSplide();
    mmInitDiscountAccordion();

    if (wasOpen) {
      const newDiscountWrapper = document.querySelector('.mm-discount-wrapper');
      if (newDiscountWrapper) {
        newDiscountWrapper.classList.add('mm-open');
      }
    }
    if (callback) callback();
  }
  const request = new XMLHttpRequest();
  request.addEventListener('load', handleResponse);
  request.open('GET', '/?section_id=mm-cart', true)
  request.send()
}

// Fermer le panier
function mmCloseCart() {
  document.querySelector('.mm-drawer-cart-filter').classList.remove('mm-dc-is-open');
  document.querySelector('html').classList.remove('stop-scrolling');
}

// Re-render cart inner HTML from response
function refreshCartFromData(data) {
  const discountWrapper = document.querySelector('.mm-discount-wrapper');
  const wasOpen = discountWrapper && discountWrapper.classList.contains('mm-open');

  const newCartEl = document.createElement('DIV');
  newCartEl.innerHTML = data.sections["mm-cart"];
  const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-filter");
  innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-filter").innerHTML;
  mmInitSplide();
  console.log('Panier rechargé via refreshCartFromData');
  mmInitDiscountAccordion();

  if (wasOpen) {
    const newDiscountWrapper = document.querySelector('.mm-discount-wrapper');
    if (newDiscountWrapper) {
      newDiscountWrapper.classList.add('mm-open');
    }
  }

  return data;
}

// Ajouter un item au panier
function mmAddProductToCart(productId, { quantity = 1, openCart = true }) {
    
  if (document.getElementById('mmChoixDesSavons')) {
    var LIproperty = document.getElementById('mmChoixDesSavons').value
  }
  
  mmAPIRequest('POST', 'cart/add.js', {
    items: [
      { 
        quantity: quantity, 
        id: productId,  
        properties: {
          'Savons': LIproperty
        }
      }
    ],
    sections: "mm-cart",
  })
    .then(refreshCartFromData)
    .then(mmAddOrRemoveFreeProducts)
    .then((data) => {
      if (openCart) {
        setTimeout(mmOpenCart); 
      }
    }).catch((error) => {
      mmCartProductsContainerElement().innerHTML = `
      Oups, il y a eu une erreur, essayez de recharger la page !
      `;
      mmOpenCart();
      console.log(error);
    })
}

// Ajouter un item au panier avec des properties
function mmAddProductToCartWithproperties(productId, { quantity = 1, openCart = true }, produitsRoutine) {
    
  if (document.getElementById('mmChoixDesSavons')) {
    var LIproperty = document.getElementById('mmChoixDesSavons').value
  }

  var variantSelected = document.querySelector('.mm-product-variant-checkbox:checked');
  if(variantSelected) {
    if(produitsRoutine === undefined) {} else {
      var produitsRoutine = produitsRoutine + ' | ' + variantSelected.name.replace('options[','').replace(']','').toUpperCase() + ": " + variantSelected.value.toUpperCase();      
    }
  }
  mmAPIRequest('POST', 'cart/add.js', {
    items: [
      { 
        quantity: quantity, 
        id: productId,  
        properties: {
          'Savons': LIproperty,
          'Produits': produitsRoutine
        }
      }
    ],
    sections: "mm-cart",
  })
    .then(refreshCartFromData)
    .then(mmAddOrRemoveFreeProducts)
    .then((data) => {
      if (openCart) {
        setTimeout(mmOpenCart); 
      }
    }).catch((error) => {
      mmCartProductsContainerElement().innerHTML = `
      Oups, il y a eu une erreur, essayez de recharger la page !
      `;
      mmOpenCart();
      console.log(error);
    })
}

function mmIncreaseProductQuantity(productVariantId) {
   const quantity = mmGetCartItemQuantity(productVariantId);
   const newQuantity = quantity + 1;
   mmSetCartItemQuantity(productVariantId, newQuantity);

   mmDebouncedPushNewQuantity(productVariantId);
}

function mmDecreaseProductQuantity(productVariantId) {
  const quantity = mmGetCartItemQuantity(productVariantId);
  const newQuantity = quantity - 1;
  mmSetCartItemQuantity(productVariantId, newQuantity);

  mmDebouncedPushNewQuantity(productVariantId);
}

function mmDestroyProductFromCart(productVariantId) {
  const newQuantity = 0;
  mmSetCartItemQuantity(productVariantId, newQuantity);

  mmDebouncedPushNewQuantity(productVariantId);
}

function mmPushNewQuantity(productVariantId) {
  const quantity = mmGetCartItemQuantity(productVariantId);
  
  mmAPIRequest('POST', 'cart/change.js', {
    id: productVariantId.toString(), quantity: quantity, sections: "mm-cart" 
  }).then(mmAddOrRemoveFreeProducts)
    .then(refreshCartFromData);
}

function mmChangeFreeProductInCart(productVariantIdToAdd, productVariantIdToRemove, clickedElem) { 
  
  // Debounce sur le CTA
  clickedElem.innerText = "AJOUTÉ !";
  clickedElem.classList.add('mm-disabled');  
  
    
    
  mmAPIRequest('POST', 'cart/add.js', {
    items: [{ quantity: 1, id: productVariantIdToAdd }],
    sections: "mm-cart",
  }).then(mmDestroyProductFromCart(productVariantIdToRemove));
}

const mmDebouncedPushNewQuantity = debounce(function(productVariantId) {
  mmPushNewQuantity(productVariantId);
}, 300);

function mmDestroyFreeProductForEver(freeProductId) {
  var freeProductName = 'free_product_cancelled_' + freeProductId;
  localStorage.setItem(freeProductName, "true");
}

function mmAddOrRemoveFreeProducts(data) {
    if (data.sections["mm-cart"]) {
        const el = mmCartHTMLFromData(data);
        const freeProductEls = el.querySelector("[data-free-products]");
        let freeProductCounts = 0;

        // creates an object like { 44058675: 1, 44058001: 0 }
        // where key is free product id and value, its quantity
        const productsParams = Array.from(freeProductEls.children).reduce((param, freeProductEl) => {
            const productId = freeProductEl.dataset.variantId;
            const isFree = freeProductEl.dataset.freeProduct == "true";
            const itemEl = mmCartItem(productId);
            var freeProductName = 'free_product_cancelled_' + productId;
            var doNotAdd = freeProductEl.dataset.doNotAdd;
          
            if((freeProductEl.dataset.freeProductAmount * 100) > el.querySelector('.mm-drawer-cart').dataset.cartTotal) {
              localStorage.setItem(freeProductName, "false");
            }
          
            if (isFree) {
                freeProductCounts += 1;
            }

          console.log('isFree', freeProductEl.dataset.freeProduct)

            if (itemEl && isFree) {
                console.log("do nothing, item is already added");
                // do nothing, item is already added
            } else if (itemEl && !isFree) {
                console.log("item is present but should be removed", productId);
                // item is present but should be removed
                param[productId] = 0;
            } else if (!itemEl && isFree) {
                if(doNotAdd == "false") {
                  console.log("item is absent but should be added", productId);
                  // item is absent but should be added
                  if (!localStorage.getItem(freeProductName)){
                    localStorage.setItem(freeProductName, "false");
                  }
                  if(localStorage.getItem(freeProductName) == 'false'){
                    param[productId] = 1;  
                  }                  
                } else {
                  console.log("do not add item", productId);                  
                }
            }
            return param;
        }, {});

        // Add or remove free products only if needed
        if (Object.keys(productsParams).length > 0) {
            console.log("productsParams", productsParams);
            mmAPIRequest("POST", "cart/update.js", { updates: productsParams, sections: "mm-cart" }).then(refreshCartFromData);
        }
    }
    return data;
}

function mmAddFreeProductToCart(productId, { quantity = 1, openCart = true }, clickedElem) {
    // Debounce sur le CTA
    clickedElem.innerText = "AJOUTÉ !";
    clickedElem.classList.add("mm-disabled");

    // Ajouter le free product
    mmAddProductToCart(productId, { openCart: false });
}

window.addEventListener("DOMContentLoaded", (event) => {
    mmGetCart().then(mmInitDiscountAccordion);
});